import { createApp } from "vue"
import App from "./App.vue"
import router from "./router"

import "@/styles/components.scss"
import "~brandcss"

import { VueQueryPlugin } from "@tanstack/vue-query"
import { queryClient } from "@/queryClient"
import { createHead } from "@unhead/vue"

const app = createApp(App)
const head = createHead()

app.use(VueQueryPlugin, { queryClient })
app.use(head)
app.use(router)
app.mount("#app")
